import AuditLogsScreen from "app/features/auditLog/screens/AuditLogsScreen";

export default function AuditLogsPage() {
  return <AuditLogsScreen />;
}
